export default {
    attachmentsReceived: '{{documentsCount}} Documento(s) Adjuntos Recibidos',
    disputeAmount: 'Disputas Monto',
    disputeDate: 'Disputas Fecha',
    disputeDetails: 'Detalles de la disputa',
    disputeHistory: 'Historial de disputas',
    disputeID: 'ID de disputa',
    documentsReceived: 'Documentos recibidos',
    originalDisputeAmount: 'Monto original de la disputa',
    originalDisputeID: 'ID de disputa original',
    originalDisputeReason: 'Motivo original de la disputa',
    originalTransaction: 'Transacción Original',
    recommendedDocumentation: '<0>Recomendamos documentación</0>: {{disputeReason}}'
};
//# sourceMappingURL=disputeDetails.js.map